import React, { CSSProperties } from 'react'
import cn from 'classnames'
import Icon from '../Icon2/Icon'
import './CircularLoaderV2.css'

export type CircularLoaderV2Props = {
  /** Size of the loader - 'small', 'medium', or 'large' */
  size?: 'small' | 'medium' | 'large' | 'button' | 'button-small' | 'button-large'
  /** Custom styles for the loader container */
  style?: CSSProperties
  /** Additional CSS class names */
  className?: string
  /** Test ID for testing purposes */
  testId?: string
}

const CircularLoaderV2: React.FC<CircularLoaderV2Props> = ({
  size = 'medium',
  style = {},
  className,
  testId = 'cs-circular-loader-v2'
}) => {
  const classNames = cn('CircularLoaderV2', {
    [`CircularLoaderV2--size-${size}`]: size
  }, className)

  return (
    <div style={style} className={classNames} data-test-id={testId}>
      <Icon icon="PurpleLoader" className="CircularLoaderV2__icon" />
    </div>
  )
}

export default CircularLoaderV2
